var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWhatshot = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "46px",
    viewBox: "0 0 34 46",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "45AF9180-03C9-40A7-8986-FB1C0A557DBE")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-New-Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Builder---New-Workflow---08",
    transform: "translate(-474.000000, -542.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(297.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(0.000000, 166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(169.100000, 62.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Geography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User---Index---Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Available-Filters---01-Outlined-/-Social-/-whatshot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Social-/-whatshot"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 50 0 50 50 0 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1041667,27.4166662 C21.2708335,27.9999995 19.5833335,29.8333328 19.5833335,32.4374995 C19.5833335,35.2291661 21.8958335,37.4791661 24.7708334,37.4791661 C29.0416666,37.4791661 32.4999998,34.0208328 32.4999998,29.7499996 C32.4999998,27.5208328 32.1874998,25.3333329 31.5416665,23.2499996 C29.8958332,25.4791662 26.9583333,26.8333329 24.1041667,27.4166662 Z M28.125,1.39583337 C28.125,1.39583337 29.6666667,6.91666668 29.6666667,11.3958334 C29.6666667,15.6875 26.8541667,19.1666666 22.5625,19.1666666 C18.25,19.1666666 15,15.6875 15,11.3958334 L15.0625,10.6458333 C10.8541667,15.6458333 8.33333333,22.125 8.33333333,29.1666666 C8.33333333,38.3749999 15.7916667,45.8333332 25,45.8333332 C34.2083333,45.8333332 41.6666667,38.3749999 41.6666667,29.1666666 C41.6666667,17.9375 36.2708333,7.91666668 28.125,1.39583337 Z M25,41.6666655 C18.1041667,41.6666655 12.5,36.0624991 12.5,29.166666 C12.5,25.9791661 13.125,22.8333329 14.2916667,19.9374996 C16.3958333,22.0416662 19.3125,23.3333329 22.5625,23.3333329 C28.1041667,23.3333329 32.4583333,19.520833 33.5625,14.1041665 C36.125,18.6874997 37.5,23.8333328 37.5,29.166666 C37.5,36.0624991 31.8958333,41.6666655 25,41.6666655 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))))))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhatshot, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whatshot.9cc476d2.svg";
export { ForwardRef as ReactComponent };